import { REPORTS_MOCK } from '../mock';

export const useGetReports = () => {
  return { reports: REPORTS_MOCK };
};
